<div class="app-main__inner">

    <div class="app-page-title">
        <div class="page-title-wrapper">
            <div class="page-title-heading">
                <div class="page-title-icon">
                    <i class="pe-7s-users icon-gradient bg-tempting-azure"></i>
                </div>
                <div>
                    Recipients Group
                    <div class="page-title-subheading">
                        Build reusable recipient lists by combining groups. Use them in Trigger Campaign.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Save result alert -->
    <div *ngIf="saveResult" class="alert py-2 px-3 mb-3"
        [ngClass]="saveResultSuccess ? 'alert-success' : 'alert-danger'">
        <i [ngClass]="saveResultSuccess ? 'pe-7s-check' : 'pe-7s-attention'" class="me-1"></i>
        {{ saveResult }}
    </div>

    <!-- Builder card -->
    <div class="card mb-4">
        <div class="card-header d-flex align-items-center gap-2">
            <i class="pe-7s-filter me-1"></i>
            <span class="fw-semibold">Build Recipient List</span>
            <span *ngIf="selectedCount > 0" class="badge bg-primary rounded-pill ms-auto">
                {{ selectedCount }} / {{ customerPool.length }} selected
            </span>
        </div>
        <div class="card-body p-0">
            <div class="row g-0" style="min-height: 320px;">

                <!-- Column 1: L1 Masters -->
                <div class="col-md-3 border-end">
                    <div class="col-header">MASTER TYPE</div>
                    <div *ngIf="isLoadingMasters" class="text-center py-4 text-muted">
                        <span class="spinner-border spinner-border-sm"></span>
                    </div>
                    <div *ngIf="!isLoadingMasters && genericMasters.length === 0" class="text-center py-4 text-muted small">
                        No masters configured yet.
                    </div>
                    <ul *ngIf="!isLoadingMasters && genericMasters.length > 0" class="rl-list">
                        <li *ngFor="let m of genericMasters; trackBy: trackById"
                            class="rl-item"
                            [class.rl-item--active]="selectedL1?._id === m._id"
                            (click)="selectL1(m)">
                            <i class="pe-7s-folder me-2"></i>
                            {{ m.masterName }}
                        </li>
                    </ul>
                </div>

                <!-- Column 2: L2 Values -->
                <div class="col-md-3 border-end">
                    <div class="col-header">
                        {{ selectedL1 ? (selectedL1.fieldLabel || selectedL1.masterName) : 'VALUES' }}
                    </div>
                    <div *ngIf="!selectedL1" class="text-center py-4 text-muted small">
                        ← Select a master type
                    </div>
                    <div *ngIf="selectedL1 && isLoadingL2" class="text-center py-3 text-muted">
                        <span class="spinner-border spinner-border-sm"></span>
                    </div>
                    <ul *ngIf="selectedL1 && !isLoadingL2" class="rl-list">
                        <li *ngIf="l2Values.length === 0" class="text-center py-3 text-muted small">No values</li>
                        <li *ngFor="let v of l2Values; trackBy: trackById"
                            class="rl-item rl-item--l2"
                            [class.rl-item--added]="isGroupAdded(v)">
                            <span class="rl-item__label"><i class="pe-7s-tag me-1"></i>{{ v.value }}</span>
                            <button *ngIf="!isGroupAdded(v)" class="btn btn-sm btn-outline-primary py-0 px-2"
                                [disabled]="isLoadingGroup[v._id]"
                                (click)="addGroup(v); $event.stopPropagation()">
                                <span *ngIf="isLoadingGroup[v._id]" class="spinner-border spinner-border-sm"></span>
                                <span *ngIf="!isLoadingGroup[v._id]">+ Add</span>
                            </button>
                            <span *ngIf="isGroupAdded(v)" class="badge bg-success-subtle text-success border border-success-subtle" style="font-size:0.7rem;">Added</span>
                        </li>
                    </ul>
                </div>

                <!-- Column 3: Customer pool + save form -->
                <div class="col-md-6 d-flex flex-column">
                    <div class="col-header d-flex justify-content-between align-items-center">
                        <span>CUSTOMER POOL</span>
                        <span *ngIf="customerPool.length > 0" class="text-muted" style="font-size:0.72rem;">
                            {{ selectedCount }} / {{ customerPool.length }} selected
                        </span>
                    </div>

                    <!-- Group chips -->
                    <div *ngIf="selectedGroups.length > 0" class="p-2 d-flex flex-wrap gap-1 border-bottom">
                        <span *ngFor="let g of selectedGroups; trackBy: trackByIndex" class="group-chip">
                            <span class="group-chip__label">{{ g.l1Name }}: {{ g.l2Name }}</span>
                            <span class="group-chip__count">({{ g.customers.length }})</span>
                            <button class="group-chip__remove" (click)="removeGroup(g)" title="Remove group">&times;</button>
                        </span>
                    </div>

                    <!-- Search + Select All bar -->
                    <div *ngIf="customerPool.length > 0" class="pool-controls border-bottom">
                        <div class="pool-search">
                            <i class="pe-7s-search pool-search__icon"></i>
                            <input type="text" class="pool-search__input"
                                [(ngModel)]="searchQuery"
                                placeholder="Search by name or number…" />
                            <button *ngIf="searchQuery" class="pool-search__clear" (click)="searchQuery = ''">×</button>
                        </div>
                        <label class="select-all-row">
                            <input type="checkbox"
                                class="form-check-input me-2"
                                [checked]="allFilteredSelected"
                                [indeterminate]="selectedCount > 0 && !allFilteredSelected"
                                (change)="toggleSelectAll()" />
                            <span class="small fw-medium">
                                {{ allFilteredSelected ? 'Deselect All' : 'Select All' }}
                                <span class="text-muted fw-normal">
                                    ({{ filteredPool.length }}{{ searchQuery ? ' matching' : '' }})
                                </span>
                            </span>
                        </label>
                    </div>

                    <!-- Empty state -->
                    <div *ngIf="selectedGroups.length === 0" class="flex-grow-1 d-flex align-items-center justify-content-center text-muted small">
                        ← Add at least one group to build the customer pool
                    </div>

                    <!-- Customer list (filtered) -->
                    <div *ngIf="customerPool.length > 0" class="customer-pool-list">
                        <div *ngIf="filteredPool.length === 0" class="text-center py-4 text-muted small">
                            No customers match "<strong>{{ searchQuery }}</strong>"
                        </div>
                        <div *ngFor="let c of filteredPool; trackBy: trackById"
                            class="customer-row"
                            [class.customer-row--selected]="isSelected(c)"
                            (click)="toggleCustomer(c)">
                            <input type="checkbox" class="form-check-input me-2 flex-shrink-0"
                                [checked]="isSelected(c)"
                                (click)="$event.stopPropagation()"
                                (change)="toggleCustomer(c)" />
                            <div>
                                <div class="fw-medium small">{{ c.name }}</div>
                                <div class="text-muted" style="font-size:0.75rem;">{{ c.whatsAppNo }}</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="selectedGroups.length > 0 && customerPool.length === 0" class="flex-grow-1 d-flex align-items-center justify-content-center text-muted small">
                        No customers assigned to the selected group(s) yet.
                    </div>

                    <!-- Save bar -->
                    <div *ngIf="customerPool.length > 0" class="p-3 border-top bg-light">
                        <div class="d-flex gap-2 align-items-center">
                            <input type="text" class="form-control form-control-sm"
                                [(ngModel)]="listName"
                                placeholder="List name (e.g. Managers – Aug 2026)"
                                maxlength="80" />
                            <button class="btn btn-primary btn-sm px-3 flex-shrink-0"
                                [disabled]="!canSave"
                                (click)="saveList()">
                                <span *ngIf="isSaving"><span class="spinner-border spinner-border-sm me-1"></span></span>
                                <span *ngIf="!isSaving"><i class="pe-7s-diskette me-1"></i></span>
                                Save ({{ selectedCount }})
                            </button>
                        </div>
                        <div *ngIf="!listName.trim() && customerPool.length > 0" class="text-muted small mt-1">
                            Enter a list name to save.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Saved lists -->
    <div class="card">
        <div class="card-header d-flex align-items-center gap-2">
            <i class="pe-7s-bookmark me-1"></i>
            <span class="fw-semibold">Saved Recipient Lists</span>
            <span class="badge bg-secondary rounded-pill ms-1">{{ savedLists.length }}</span>
        </div>
        <div class="card-body p-0">
            <div *ngIf="isLoadingLists" class="text-center p-4 text-muted">
                <span class="spinner-border spinner-border-sm me-2"></span> Loading...
            </div>
            <div *ngIf="!isLoadingLists && savedLists.length === 0" class="text-center p-4 text-muted">
                No saved lists yet. Build one above and click Save.
            </div>
            <div *ngIf="!isLoadingLists && savedLists.length > 0">
                <vio-table-v2
                    [tableData]="savedListsForTable"
                    [tableConfig]="savedListsTableConfig">
                </vio-table-v2>
            </div>
        </div>
    </div>

</div>

<!-- View Recipients Modal -->
<div #viewListModal class="modal fade" tabindex="-1" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="pe-7s-users me-2"></i>{{ viewListTitle }}
                    <span class="badge bg-primary rounded-pill ms-2">{{ viewListCustomers.length }}</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-0" style="max-height: 60vh; overflow-y: auto;">
                <div *ngIf="viewListCustomers.length === 0" class="text-center p-4 text-muted">
                    No recipients in this list.
                </div>
                <table *ngIf="viewListCustomers.length > 0" class="table table-sm table-hover align-middle mb-0">
                    <thead class="table-light">
                        <tr>
                            <th class="ps-3">#</th>
                            <th>Name</th>
                            <th>WhatsApp No</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of viewListCustomers; let i = index; trackBy: trackById">
                            <td class="ps-3 text-muted small">{{ i + 1 }}</td>
                            <td class="fw-medium">{{ c.name }}</td>
                            <td class="text-muted small">{{ c.whatsAppNo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
